import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { T } from "../EditContext";
import { Heading } from "./Sections";
import { accentCard } from "../accent";

const COLS = { 2: "sm:grid-cols-2", 3: "sm:grid-cols-2 lg:grid-cols-3", 4: "sm:grid-cols-2 lg:grid-cols-4" };

// Plain editable cards — the fallback block for anything the product page doesn't cover.
export const PlainCards = ({ props: p = {} }) => {
    const cards = (p.cards || []).filter((c) => c.visible !== false);
    if (!cards.length && !p.heading) return null;
    const section = accentCard(p.accent || "gold", p.accent_hex);

    return (
        <section className="mx-auto max-w-7xl px-6 md:px-12 py-10 md:py-14" data-testid="plain-cards">
            {p.eyebrow && <T f="eyebrow" value={p.eyebrow} as="div" className="eyebrow mb-3" />}
            {p.heading && <Heading f="heading" value={p.heading} />}
            {p.body && <T f="body" value={p.body} as="p" multiline className="mt-4 text-zinc-500 max-w-3xl" />}

            <div className={`mt-10 grid gap-5 ${COLS[p.columns] || COLS[3]}`}>
                {cards.map((c, i) => {
                    const a = c.accent ? accentCard(c.accent, c.accent_hex) : section;
                    const inner = (
                        <>
                            <span aria-hidden className="sci-rule" />
                            {c.image_url && (
                                <div className="h-36 flex items-center justify-center mb-5">
                                    <img src={c.image_url} alt={c.title || ""} className="max-h-full object-contain" />
                                </div>
                            )}
                            {c.tag && (
                                <div className="mono text-[9px] tracking-[0.2em]" style={{ color: a.hex }}>
                                    {c.tag.toUpperCase()}
                                </div>
                            )}
                            {c.title && <h3 className="font-display text-xl uppercase tracking-tight mt-2">{c.title}</h3>}
                            {c.desc && <p className="text-sm text-zinc-500 mt-2 leading-relaxed whitespace-pre-line">{c.desc}</p>}
                            {c.link && (
                                <span className="mt-5 inline-flex items-center gap-2 mono text-[10px] tracking-[0.2em]"
                                    style={{ color: a.hex }}>
                                    {(c.link_label || "Read more").toUpperCase()} <ArrowRight className="w-3.5 h-3.5" />
                                </span>
                            )}
                        </>
                    );
                    const cls = `${a.className} p-6 pt-7 transition-transform duration-500 hover:-translate-y-1`;
                    return c.link
                        ? <Link key={i} to={c.link} className={`${cls} block`} style={a.style}
                            data-testid={`plain-card-${i}`}>{inner}</Link>
                        : <div key={i} className={cls} style={a.style} data-testid={`plain-card-${i}`}>{inner}</div>;
                })}
            </div>
        </section>
    );
};

export default PlainCards;
